import { render } from "./Unsupported_Browser_Snackbar.vue?vue&type=template&id=06dd339c"
import script from "./Unsupported_Browser_Snackbar.vue?vue&type=script&lang=js"
export * from "./Unsupported_Browser_Snackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__